module.exports = __webpack_public_path__ + "img/ecom-auchan.7bc79371.png";